import React, { lazy, Suspense, useMemo } from 'react'

interface TemplateData {
  template: string // e.g., 'cards/Card'
  props: Record<string, any>
}

interface ContentfulJsonDataObjectProps {
  data: TemplateData
}

const ContentfulJsonDataObject: React.FC<
  ContentfulJsonDataObjectProps & { contentObject?: any }
> = ({ data, contentObject }) => {
  let templateData = data
  if (contentObject?.internal?.content && !data?.template) {
    try {
      const component = JSON.parse(contentObject.internal.content)
      templateData = {
        template: component.componentTemplate,
        props: component.content
      }
    } catch (error) {
      // Don't return early - let hooks run first
      templateData = null
    }
  }

  const { template, props } = templateData || {}

  const LazyComponent = useMemo(() => {
    if (!template) {
      return null
    }
    try {
      return lazy(() =>
        import(`../Snowflake/${template}`).catch(() => {
          // Return a fallback component if the module doesn't exist
          return {
            default: (() => null) as React.ComponentType<any>
          }
        })
      )
    } catch (error) {
      return null
    }
  }, [template])

  if (!templateData || !template) {
    return null
  }

  if (!LazyComponent) {
    return <div>Error: Unknown template "{template}"</div>
  }

  return (
    <Suspense fallback={<div> </div>}>
      <LazyComponent {...props} />
    </Suspense>
  )
}

export default ContentfulJsonDataObject
